
<div class="mb-5">

    <Pagination class="d-none d-md-flex" :pages="pages" v-model="page" :total="total" :pageSize="pageSize"/>
    <label for="" class="filter-title-mobile">{{ $locale == 'es' ? 'Filtros' : 'Filters' }}:
    </label>

    <div class="catalog-layout">

        <Filters
            class="col-12 col-sm-12 col-md-3 col-lg-2"
            :filters="filters"
            :locale="locale"
            :configTexts="configTexts"
            :customOrder="config.component === 'Catalog'"
            @getData="getData"
            @resetPage="resetPage"
        />
        <div class="d-flex flex-column col-12 col-sm-12 col-md-9 col-lg-10">
            <Pagination class="d-flex d-md-none" :pages="pages" v-model="page" :total="total" :pageSize="pageSize"/>
            <List ref="list"
                class=""
                :config="config"
                :locale="locale"
                :configTexts="configTexts"
                :page="page"
                :pageSize="pageSize"
                :metadata="metadata"
                :status="status"
                :total="total"
                :pages="pages"
                @updateMetadata="updateMetadata"/>
        </div>
        
    </div>

    <Pagination :pages="pages" v-model="page" :total="total" :pageSize="pageSize"/>
    
    <template v-if="configTexts && configTexts.mapText">
        <a class="btn btn-primary d-flex d-md-none flex-nowrap align-items-center justify-content-center mt-4" :href="terminalsUrl">
            <span class="pe-3" v-html="configTexts.mapText"></span> <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon">
        </a>
    </template>
    
    <div class="d-flex d-md-none w-100">
        <div class="my-3 w-100" v-if="configTexts && configTexts.banner">
            <div class="banner catalog-banner text-center d-flex flex-row flex-md-column py-2 px-3 px-sm-5 px-md-2 justify-content-center align-items-center">
                <img v-if="configTexts.banner.image && configTexts.banner.image.value" :src="configTexts.banner.image.value.public_path" class="catalog-img"/>
                <span class="filter-banner-span" v-if="configTexts.banner.text && configTexts.banner.text.value" v-html="configTexts.banner.text.value"/>
            </div>
            <a class="btn btn-secondary d-flex flex-nowrap align-items-center justify-content-center"
                :href="downloadsUrl"
                v-if="configTexts.banner.cta && configTexts.banner.cta.value">

                <span class="pe-3">{{configTexts.banner.cta.value.title}}</span>
                <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon">
            </a>
        </div>
    </div>

</div>
